import React, { useEffect } from 'react';
import { DossierBackdrop } from '../components/DossierBackdrop';
import { UrgencyBar } from '../components/UrgencyBar';
import { CaseIndex } from '../components/CaseIndex';
import { CaseIndexStrip } from '../components/CaseIndexStrip';
import { CaseCover } from '../components/CaseCover';
import { StoryFile } from '../components/StoryFile';
import { EvidenceSection } from '../components/EvidenceSection';
import { PriceFile } from '../components/PriceFile';
import { GuaranteeFile } from '../components/GuaranteeFile';
import { FaqFile } from '../components/FaqFile';
import { ClosingFile } from '../components/ClosingFile';
import { DossierActionBar } from '../components/DossierActionBar';
import { LiveViewers } from '../components/LiveViewers';
import { SalesNotifications } from '../components/SalesNotifications';
import { useActiveSection } from '../hooks/useActiveSection';
import { scheduleMetaPixel } from '../utils/metaPixel';
import { dossierSections } from '../data/dossierSections';
import { storyBeats } from '../data/story';
interface DossierPageProps {
  spotsLeft: number;
  redactedIntros: boolean;
}
export function DossierPage({
  spotsLeft,
  redactedIntros
}: DossierPageProps) {
  const activeId = useActiveSection(dossierSections.map(s => s.id));
  useEffect(() => scheduleMetaPixel(), []);
  return <div className="relative min-h-screen w-full bg-ink font-sans text-bone antialiased" data-id="element-416" data-mp="2fl6svwf2zzsq">
      <DossierBackdrop data-id="element-417" data-mp="33b13s8fubeac" />
      <UrgencyBar spotsLeft={spotsLeft} data-id="element-418" data-mp="33araobzi0r0f" />
      <CaseIndex activeId={activeId} data-id="element-419" data-mp="388ssktl6ukab" />
      <CaseIndexStrip activeId={activeId} data-id="element-420" data-mp="387rjuvrna9vr" />

      <main className="relative z-10 pb-28 pt-[88px] lg:pb-32 lg:pl-[248px] lg:pt-[52px]" data-id="element-421" data-mp="2tbtqtmd0plnr">
        <CaseCover data-id="element-422" data-mp="2te643m7tz7uh" />
        {storyBeats.map(beat => <StoryFile key={beat.id} beat={beat} redacted={redactedIntros} data-id="element-423" data-mp="2y9lfm7id8rnq" />)}
        <EvidenceSection data-id="element-424" data-mp="1hvljz8qjzo6a" />
        <PriceFile data-id="element-425" data-mp="1hv3hvvh7mfqg" />
        <GuaranteeFile data-id="element-426" data-mp="1hyznikaye3fb" />
        <FaqFile data-id="element-427" data-mp="1mvhr3gujrvq2" />
        <ClosingFile data-id="element-428" data-mp="1mvzrmpo8sw3s" />

        <footer className="px-5 py-8 text-center sm:px-10 sm:py-10 lg:px-14" data-id="element-429" data-mp="1mxawytxc6bx0">
          <p className="font-mono text-[9.5px] uppercase tracking-[0.16em] text-white/25" data-id="element-430" data-mp="3phd943x0tdkm">
            Fin del expediente VDB-2026-014 · Start Launching Creatives · Todos
            los derechos reservados
          </p>
        </footer>
      </main>

      <LiveViewers data-id="element-431" data-mp="3fq8u547chsps" />
      <SalesNotifications data-id="element-432" data-mp="3ats60a05becp" />
      <DossierActionBar data-id="element-433" data-mp="3ash5cj1zympt" />
    </div>;
}